export default __webpack_public_path__ + "static/media/049-plant.60419bcc.svg";